// import React from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay } from "swiper/modules";

// import "swiper/css";

// const testimonials = [
//   {
//     name: "Mr. Rajesh Sharma",
//     role: "Business Traveler",
//     text: "Excellent Mumbai Airport cab service. The driver arrived on time, and the journey was smooth and comfortable.",
//     img: "/img/testimonial/testimonial-2-1.jpg",
//   },
//   {
//     name: "Miss. Priya Patel",
//     role: "Frequent Flyer",
//     text: "Very professional service. Booking was easy, and the cab was clean and well-maintained.",
//     img: "/img/testimonial/testimonial-2-2.jpg",
//   },
//   {
//     name: "Mr. Amit Verma",
//     role: "Corporate Client",
//     text: "Reliable airport transfer service. The driver tracked my flight and was waiting when I arrived.",
//     img: "/img/testimonial/testimonial-2-3.jpg",
//   },
//   {
//     name: "Miss. Neha Gupta",
//     role: "Tourist",
//     text: "Safe and affordable ride from Mumbai Airport. Highly recommended for travelers.",
//     img: "/img/testimonial/testimonial-2-4.jpg",
//   },
//   {
//     name: "Mr. Vikram Singh",
//     role: "Regular Customer",
//     text: "I've used this airport cab service multiple times. The drivers are always punctual, polite, and professional.",
//     img: "/img/testimonial/testimonial-2-5.jpg",
//   },
// ];

// const TestimonialSectionabout = () => {
//   return (
//     <section
//       className="space testimonial-style2 py-3"
//       style={{
//         backgroundImage: "url('/img/bg/testimonial-bg-2.jpg')",
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//       }}
//     >
//       <div className="container">
//         {/* Title */}
//         <div className="row">
//           <div className="col-lg-6 col-md-8">
//             <div className="title-area white-title">
//               <span className="sec-subtitle">Customer Reviews</span>
//               <h2 className="sec-title h1">
//                 Trusted Mumbai Airport Cab Service by Thousands of Travelers
//               </h2>
//             </div>
//           </div>
//         </div>

//         {/* Testimonial Slider */}
//         <Swiper
//           modules={[Autoplay]}
//           autoplay={{
//             delay: 3000,
//             disableOnInteraction: false,
//           }}
//           loop={true}
//           spaceBetween={20}
//           slidesPerView={2}
//           breakpoints={{
//             0: {
//               slidesPerView: 1,
//             },
//             768: {
//               slidesPerView: 2,
//             },
//           }}
//         >
//           {testimonials.map((item, index) => (
//             <SwiperSlide key={index}>
//               <div className="testi-style2">
//                 <div className="testi-body">
//                   <p className="testi-text text-dark">“{item.text}”</p>

//                   <div className="testi-rating">
//                     ⭐⭐⭐⭐⭐
//                   </div>
//                 </div>

//                 <h3 className="testi-name text-dark">{item.name}</h3>
//                 <span className="testi-degi">{item.role}</span>

                
//               </div>
//             </SwiperSlide>
//           ))}
//         </Swiper>
//       </div>
//     </section>
//   );
// };

// export default TestimonialSectionabout;




import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";

const testimonials = [
  {
    name: "Mr. Rajesh Sharma",
    role: "Business Traveler",
    text: "Excellent Mumbai Airport cab service. The driver arrived on time, and the journey was smooth and comfortable.",
    avatar:
      "https://ui-avatars.com/api/?name=Rajesh+Sharma&background=12385C&color=ffffff&size=128&rounded=true",
  },
  {
    name: "Miss. Priya Patel",
    role: "Frequent Flyer",
    text: "Very professional service. Booking was easy, and the cab was clean and well-maintained.",
    avatar:
      "https://ui-avatars.com/api/?name=Priya+Patel&background=D4A64A&color=12385C&size=128&rounded=true",
  },
  {
    name: "Mr. Amit Verma",
    role: "Corporate Client",
    text: "Reliable airport transfer service. The driver tracked my flight and was waiting when I arrived.",
    avatar:
      "https://ui-avatars.com/api/?name=Amit+Verma&background=1F5F94&color=ffffff&size=128&rounded=true",
  },
  {
    name: "Miss. Neha Gupta",
    role: "Tourist",
    text: "Safe and affordable ride from Mumbai Airport. Highly recommended for travelers.",
    avatar:
      "https://ui-avatars.com/api/?name=Neha+Gupta&background=D4A64A&color=12385C&size=128&rounded=true",
  },
  {
    name: "Mr. Vikram Singh",
    role: "Regular Customer",
    text: "I've used this airport cab service multiple times. The drivers are always punctual, polite, and professional.",
    avatar:
      "https://ui-avatars.com/api/?name=Vikram+Singh&background=12385C&color=ffffff&size=128&rounded=true",
  },
];

const TestimonialSectionabout = () => {
  return (
    <section
      className="space testimonial-style2 py-5"
      style={{
        backgroundImage: "url('/img/bg/testimonial-bg-2.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="container">

        {/* Heading */}

        <div className="row mb-5">

          <div className="col-lg-7">

            <div className="title-area white-title">

              <span className="sec-subtitle">
                Customer Reviews
              </span>

              <h2 className="sec-title h1 text-white">
                Trusted Mumbai Airport Cab Service by
                Thousands of Happy Travelers
              </h2>

            </div>

          </div>

        </div>

        <Swiper
          modules={[Autoplay]}
          loop={true}
          spaceBetween={25}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
          }}
        >

          {testimonials.map((item, index) => (

            <SwiperSlide key={index}>

              <div className="testi-style2">

                <div className="testi-body">

                  <div className="d-flex align-items-center mb-3">

                    <img
                      src={item.avatar}
                      alt={item.name}
                      className="testimonial-avatar"
                    />

                    <div className="ms-3">

                      <h4 className="mb-1 text-dark">
                        {item.name}
                      </h4>

                      <span className="text-warning fw-semibold">
                        {item.role}
                      </span>

                    </div>

                  </div>

                  <p className="testi-text text-dark">

                    "{item.text}"

                  </p>

                  <div className="testimonial-stars">

                    ★★★★★

                  </div>

                </div>

              </div>

            </SwiperSlide>

          ))}
                  </Swiper>

      </div>
    </section>
  );
};

export default TestimonialSectionabout;